// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RegistrationPageSignInLink {
  color: var(--primary-main);
  padding-left: 3px;
}
`, "",{"version":3,"sources":["webpack://./views/pages/RegistrationPage/RegistrationPage.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":[".RegistrationPageSignInLink {\n  color: var(--primary-main);\n  padding-left: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
